module.exports = __webpack_public_path__ + "static/media/官网banner-二代AI.dfa9d37c.png";